var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{staticClass:"text-capitalize",attrs:{"link":"","dense":""},on:{"click":_vm.changeLang}},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.item.title ? _vm.item.title : _vm.item))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }